




























































import { Vue, Component } from 'vue-property-decorator';
import { RouteConfig } from 'vue-router';
import { SHOW_SNACKBAR } from '../../common/constants';
import { BUDTENDER_ROUTES } from '../../common/routes.config';
import { eventBus } from '../../main';
import budtenderModule from '../../store/modules/budtender.module';

@Component({
  components: {},
})
export default class BudtenderNavbar extends Vue {
  tab = 0;

  settingButtons = [{ title: 'Logout', event: this.logout }];

  get budtenderRoutes(): Array<RouteConfig> {
    return BUDTENDER_ROUTES;
  }

  get dispensaryName(): string {
    if (!budtenderModule.dispensary) {
      return '';
    }
    return budtenderModule.dispensary.name;
  }

  created(): void {
    for (let routeIndex = 0; routeIndex < BUDTENDER_ROUTES.length; routeIndex += 1) {
      if (this.$router.currentRoute === BUDTENDER_ROUTES[routeIndex]) {
        this.tab = routeIndex;
      }
    }
  }

  selectedTabChanged(): void {
    this.$router.push(BUDTENDER_ROUTES[this.tab]);
    this.$emit('tabChanged', this.tab);
  }

  async logout(): Promise<void> {
    eventBus.$emit(SHOW_SNACKBAR, 'Logging out.');
    await budtenderModule.budtenderLogout();
  }

  buttonClicked(button: any): void {
    button.event();
  }
}
